<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Report Film</h4>
                        <div class="form-inline">
                            <span><b>Type:</b></span>
                            <select v-model="typeData" class="form-control ml-2">
                                <option value="">All</option>
                                <option value="in">In</option>
                                <option value="out">Out</option>
                            </select>
                            <span><b>Date:</b></span>
                            <datetime v-model="date" format="dd/MM/yyyy" class="form-control ml-2" value-zone="local" zone="local"></datetime>
                            <button type="button" class="btn btn-sm  btn-hard-primary waves-light waves-effect" @click="refreshList">
                              <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                            </button>
                            <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <i class="fa fa-print" aria-hidden="true"></i> Print
                            </button>
                            <div class="dropdown-menu" aria-labelledby="print">
                              <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                              <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                            </div>
                            <!-- <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery" /> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-list">
                    <div class="card-body">
                        <div class="table-responsive">
                          <table class="table table-item mb-0 table-sm table-striped table-hover">
                            <thead>
                                <th>No.</th>
                                <th>Type</th>
                                <th>Date</th>
                                <th>Hand No</th>
                                <th>Serial Number</th>
                                <th>Product</th>
                                <th class="text-center">Ukuran Potong</th>
                                <th class="text-center">Usage</th>
                                <th class="text-center">1</th>
                                <th class="text-center">2</th>
                                <th class="text-center">3</th>
                                <th class="text-center">4</th>
                                <th class="text-center">5</th>
                                <th class="text-center">6</th>
                                <th class="text-center">7</th>
                                <th class="text-center">8</th>
                                <th class="text-center">9</th>
                                <th class="text-center">10</th>
                                <th class="text-center">11</th>
                                <th class="text-center">12</th>
                                <th class="text-center">13</th>
                                <th class="text-center">14</th>
                                <th class="text-center">15</th>
                                <th class="text-center">16</th>
                                <th class="text-center">17</th>
                                <th class="text-center">18</th>
                                <th class="text-center">19</th>
                                <th class="text-center">20</th>
                                <th class="text-center">Total Usage</th>
                            </thead>
                            <tbody>
                                <tr v-for="d in dataRaw" :key="d.id">
                                    <td>{{ d.no }}</td>
                                    <td>
                                        <span class="badge badge-success" v-if="d.c_type === 'in'">{{ d.c_type }}</span>
                                        <span class="badge badge-danger" v-else>{{ d.c_type }}</span>
                                    </td>
                                    <td>{{ d.hand_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td>{{ d.hand_no }}</td>
                                    <td>{{ d.serial_number }}</td>
                                    <td><b>[{{ d.product_no }}]</b> {{ d.product_description }}</td>
                                    <td class="text-center">{{ d.qty_stock }}</td>
                                    <td class="text-center">{{ d.used_count }}</td>
                                    <td v-for="(m, index) in d.manufactures" :key="index" class="text-center">
                                        <span>{{ m.manufacture_date | dateFormat('DD/MM/YYYY') }}</span>
                                    </td>
                                    <td class="text-center">{{ d.total_used }}</td>
                                </tr>
                            </tbody>
                          </table>
                          <br>
                          <table class="table table-item mb-0 table-sm table-striped table-hover">
                            <thead>
                              <tr>
                                <th class="text-left">Produk</th>
                                <th class="text-center">Ukuran</th>
                                <th class="text-center">Jumlah</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="t in totalCounter" :key="t.id">
                                <td><b>[{{ t.product_no }}]</b> {{ t.product }}</td>
                                <td class="text-center">{{ t.qty }} {{ t.uom }}</td>
                                <td class="text-center"><b>{{ t.count }} {{ t.uom_def }}</b></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { manufacture2Url, getHeader, productUrl, inventoryUrl } from '../config'

export default {
  name: 'ManufactureReportSummaryOnHand',
  props: ['scroll'],
  components: {
    Loading
  },
  data () {
    return {
      date: new Date().toISOString(),
      typeData: 'in',
      uomList: [],
      period: [],
      period2: [],
      dataRaw: [],
      dataRaw2: [],
      proNo: null,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: 'product_no',
      pageSize: 100,
      currentPage: 1
    }
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      manufactureTypeList: state => state.manufactures.manufactureTypeList
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    totalCounter () {
      const array = this.dataRaw
      var coll = []
      var no = 0
      for (let i = 0; i < array.length; i++) {
        var product = coll.find(c => c.product_no === array[i].product_no)
        if (product !== null) {
          var qty = coll.find(c => c.product_no === array[i].product_no && c.qty === array[i].qty_stock)
          if (qty) {
            qty.count += 1
          } else {
            coll.push({
              id: no += 1,
              product_no: array[i].product_no,
              product: array[i].product_description,
              qty: array[i].qty_stock,
              uom: array[i].uom_stock,
              uom_def: array[i].uom_id,
              count: 1
            })
          }
        } else {
          coll.push({
            id: no += 1,
            product_no: array[i].product_no,
            product: array[i].product_description,
            qty: array[i].qty_stock,
            uom: array[i].uom_stock,
            uom_def: array[i].uom_id,
            count: 1
          })
        }
      }
      console.log(coll)
      return coll
    },
    filterData () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    },
    filterData2 () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw2.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async setUomList () {
      await axios.get(productUrl + '/uom', { headers: getHeader() })
        .then(response => {
          this.uomList = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.dataRaw,
        data_total: this.totalCounter
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(manufacture2Url + '/summary-onhand', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      var obj = {
        date: this.date,
        type: this.typeData
      }
      console.log(obj)
      await axios.post(inventoryUrl + '/on-hand/report-on-hand-used', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.message, 'error')
          throw error
        })
    }
  },
  mounted () {
    this.setUomList()
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getCompanyList')
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
</style>
